import React, { useEffect } from "react";

// Material UI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

// Components
import Textfield from "../../../../../../components/inputs/input";
import Dropdown from '../../../../../../components/inputs/dropdown';

// Models
import { utils } from "../../../../../../utils/utils";

//Hooks
import useCashRegisterMovementReasons from '../../../../../../hooks/cashRegisterMovementReasons/useCashRegisterMovementReasons';
import useUser from "../../../../../../hooks/user/useUser";

const Advance = ({ totals, movement, setMovement }) => {
    const { business } = useUser()
    const { cashRegisterMovementReasons } = useCashRegisterMovementReasons({ 
        type: movement.type,
        subType: movement.subType
    });

    const handleValueChange = (event) =>
        setMovement({
            ...movement,
            [event.target.name]: event.target.value,
        });

    useEffect(() => {
        if (!movement.reasonId) {
            setMovement({
                ...movement,
                reasonId: cashRegisterMovementReasons[0]?.id,
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cashRegisterMovementReasons]);

    const GetCashTotal = () =>
        totals?.[`Cash${movement.currency}`]?.total || 0;

    return (
        <Grid container spacing={1}>
            <Grid size={12}>
                <Box display="flex" justifyContent='center'>
                    <Typography variant="body1">
                        Ajuste de Caja
                    </Typography>
                </Box>
            </Grid>
            <Grid size={12}>
                <Dropdown
                    required
                    fullWidth
                    name='reasonId'
                    label='Concepto'
                    onChange={handleValueChange}
                    disabled={cashRegisterMovementReasons?.length === 1 || false}
                    getOptionValue={(option) => option?.id}
                    getOptionLabel={(option) => option?.description}
                    values={cashRegisterMovementReasons}
                    value={movement.reasonId || ""}
                />
            </Grid>
            <Grid size={3}>
                <Dropdown
                    fullWidth
                    disabled={business.currencies.length <= 1}
                    values={business.currencies}
                    size="small"
                    name="currency"
                    label="Moneda"
                    onChange={handleValueChange}
                    getOptionLabel={(option) => option}
                    getOptionValue={(option) => option}
                    value={movement?.currency || ''}
                />
                </Grid>
            <Grid size={9}>
                <Textfield
                    fullWidth
                    size="small"
                    name="amount"
                    label="Monto a depositar"
                    type="number"
                    onChange={handleValueChange}
                    value={movement?.amount || ""}
                />
            </Grid>
            <Grid size={12}>
                <Textfield
                fullWidth
                multiline
                rows={5}
                size="small"
                name="observation"
                label="Observación"
                onChange={handleValueChange}
                value={movement?.observation || ""}
                />
            </Grid>
            <Grid size={12}>
                <Box display="flex" justifyContent='flex-start'>
                    <Typography color="primary" variant="body1" gutterBottom>
                        Importe en efectivo:&nbsp;
                    </Typography>
                    <Typography variant="body1">
                        <strong>{utils.formatMoney(GetCashTotal())}</strong>
                    </Typography>
                </Box>
                <Box display="flex" justifyContent='flex-start'>
                    <Typography color="primary" variant="body1" gutterBottom>
                        Saldo restante:&nbsp;
                    </Typography>
                    <Typography variant="body1">
                        <strong>
                        {utils.formatMoney(GetCashTotal() - movement?.amount || 0)}
                        </strong>
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    );
};

export default Advance;
